<template>
  <div class="vision-select" v-show="showFlag">
    <div class="vision-select-box" :style="indeedStyle">
      <div class="vision-select-box-close" @click="close" v-if="showClose">
        <img class="vision-select-box-close-icon" src="@/assets/icons/close.png" alt="关闭" />
      </div>
      <div class="vision-select-box-title" v-if="$slots.title">
        <slot name="title"></slot>
      </div>
      <div class="vision-select-box-content" v-if="$slots.content">
        <slot name="content"></slot>
      </div>
      <div class="vision-select-box-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue';

  const showFlag = inject('showFlag');
  const props = defineProps({
    showClose: { type: Boolean, default: true },
    contentHeight: { type: Number, default: 823 },
  });
  const emit = defineEmits(['close']);
  const indeedStyle = computed(() => {
  const viewportWidth = 2560; // 设计稿的宽度
  const vwValue = (props.contentHeight / viewportWidth) * 100;
  return {
    minHeight: `${vwValue}vw`,
  };
});
  const close = () => {
    emit('close');
    // @ts-ignore
    showFlag.value = false;
  };
  const open = () => {
    // @ts-ignore
    showFlag.value = true;
  };
</script>
<style scoped lang="less">
  .vision-select {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    &-box {
      width: 1150px;
      min-height: 823px;
      background: #ffffff;
      border-radius: 60px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      padding-top: 119px;

      &-close {
        position: absolute;
        right: 60px;
        top: 60px;
        width: 46px;
        height: 46px;
        &-icon {
          width: 100%;
          object-fit: cover;
        }
      }
      &-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      &-footer {
        position: absolute;
        bottom: 79px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>
